import { IOfferState } from '../types';

export const UPDATE_OFFER = 'OFFER :: UPDATE';

export type TOfferUpdateAction = {
  type: typeof UPDATE_OFFER;
  payload: Partial<IOfferState>;
};

export function updateOffer(payload: Partial<IOfferState>): TOfferUpdateAction {
  return {
    type: UPDATE_OFFER,
    payload,
  };
}
